<template>
  <CustomModal
    :visible="visible"
    :width="'45vw'"
    title="Map variables to CSV columns"
    source="map_variables_to_columns"
    @update:visible="handleClose"
  >
    <div class="flex flex-col gap-4 p-2">
      <div class="flex flex-row gap-4 secondary_color text-[13px] font-semibold pb-2">
        <div class="flex-1">Agent Variables</div>
        <div class="flex-1">Mapping Value</div>
      </div>

      <div class="flex flex-col gap-4 max-h-[400px] overflow-y-auto custom-scrollbar">
        <div
          v-for="variable in variables"
          :key="variable.id"
          class="flex flex-row gap-4 items-center"
        >
          <div class="flex-1 secondary_color text-[13px]">
            {{ variable.variable_name }}
          </div>
          <div class="flex-1">
            <a-select
              v-model:value="variableMapping[variable.variable_name]"
              placeholder="Select column"
              class="w-full"
              :options="entityFieldOptions"
              :field-names="{ label: 'label', value: 'value' }"
            />
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="flex flex-row justify-between w-full">
        <a-button class="secondary_medium" @click="handleClose">
          Cancel
        </a-button>
        <a-button
          class="primary_medium"
          @click="handleSave"
        >
          Save changes
        </a-button>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import CustomModal from "@/src/components/CustomModal.vue";
import { entityFieldOptions } from "@/src/constants/voiceAgentConstants.js";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  variables: {
    type: Array,
    default: () => [],
  },
  campaignId: {
    type: [Number, String],
    default: null,
  },
  voiceAgentId: {
    type: [Number, String],
    default: null,
  },
  savedMapping: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:visible", "mapping-saved"]);

const variableMapping = ref({});

const populateMapping = () => {
  try {
    if (props.savedMapping && Object.keys(props.savedMapping).length > 0) {
      variableMapping.value = JSON.parse(JSON.stringify(props.savedMapping));
    } else {
      variableMapping.value = {};
    }
  } catch (error) {
    console.error("Error populating mapping:", error);
  }
};

const handleClose = () => {
  try {
    emit("update:visible", false);
  } catch (error) {
    console.error("Error closing modal:", error);
  }
};

const handleSave = () => {
  try {
    emit("mapping-saved", variableMapping.value);
    handleClose();
  } catch (error) {
    console.error("Error handling save:", error);
  }
};

watch(() => props.visible, (newVal) => {
  if (newVal) {
    populateMapping();
  }
}, { immediate: true });

watch(() => props.savedMapping, () => {
  populateMapping();
}, { deep: true, immediate: true });


onMounted(() => {
  populateMapping();
});
</script>

